import moment from "moment";
import { Button, Modal, Tag } from "rsuite";
import format_number from "../../Helpers/number_formatter";
import { serviceTypes } from "../../Constants/types";
import Grid from "../Grid";
import { useState } from "react";
import { APi } from "../../Api";
import ListTransactions from "../../Screens/JournalCheckout/ListTransactions";

const TransactionParentModal = ({ open, handleClose, data }) => {
  const [show, setShow] = useState(false);
  const [transactionsData, setTransactionsData] = useState([]);

  const displayAction = (id) => {
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Transaction +
        `/GetTransactionParentByIdWithTransactions/${id}`
    )
      .fetchAll()
      .then((res) => {
        setTransactionsData(res.data.transactions);
      })
      .catch((e) => {
        console.error(e);
        setTransactionsData([]);
      });
  };

  const columns = [
    {
      value: "date",
      name: "Date",

      render: (v) => (
        <h6
          style={{
            fontSize: "12px",
          }}
        >
          {moment(v).format("DD MMM YYYY")}
        </h6>
      ),
    },

    {
      value: "infosB2C",
      name: "Client",
      render: (v) => (
        <b style={{ color: "#4c67c2" }}>{v ? v.fullName.toUpperCase() : "-"}</b>
      ),
    },

    {
      value: "amount",
      name: "Totale",
      render: (v) => (
        <b style={{ fontSize: "14px", color: "#549f0a" }}>
          {v ? format_number(v) : ""}
        </b>
      ),
    },
    {
      value: "amountToBePaid",
      name: "Reste à payé",
      render: (v) => (
        <b style={{ fontSize: "14px" }}>{format_number(v || 0)}</b>
      ),
    },

    {
      value: "paymentStatus",
      name: "Status",
      render: (v) => (
        <b style={{ fontSize: "14px", color: v === 1 && "#549f0a" }}>
          {v === 0 ? "Partiellement payé" : "Payé"}
        </b>
      ),
    },

    {
      value: "checkout",
      name: "Caisse",
      render: (v) => <b style={{ color: "#4c67c2" }}>{v ? v.name : "-"}</b>,
    },

    {
      value: "service",
      name: "Service",
      render: (v) =>
        v ? (
          <Tag
            color={
              v == 1
                ? "blue"
                : v == 2
                ? "green"
                : v == 3
                ? "red"
                : v == 4
                ? "black"
                : v == 5
                ? "orange"
                : v == 6
                ? "violet"
                : v == 7
                ? "yellow"
                : "teal"
            }
          >
            {serviceTypes.find((el) => el.value == v)
              ? serviceTypes.find((el) => el.value == v).label
              : "Autres"}
          </Tag>
        ) : (
          "-"
        ),
    },
  ];
  return (
    <Modal
      size="l"
      overflow={false}
      style={{
        maxHeight: "calc(100vh - 50px)",
        overflow: "auto",
        width: "90vw",
        margin: "auto",
      }}
      open={open}
      onClose={handleClose}
    >
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div style={{ maxHeight: "calc(100vh - 240px)", overflow: "auto" }}>
          <Grid
            actionKey="id"
            columns={columns}
            noAdvancedActions
            rows={data}
            displayAction={(id) => {
              displayAction(id);
              setShow(true);
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} appearance="subtle">
          Annuler
        </Button>
      </Modal.Footer>
      <ListTransactions
        show={show}
        close={() => setShow(false)}
        data={transactionsData}
      />
    </Modal>
  );
};

export default TransactionParentModal;
